import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API });

// Set by AppContext so any 402 (subscription locked) anywhere in the app can trigger a
// subscription refresh, without api.js importing from AppContext (avoids a circular import).
export const billingHooks = { onLocked: null };

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("dm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

http.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 402) {
      billingHooks.onLocked?.();
    }
    return Promise.reject(err);
  }
);

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return e?.message || "Something went wrong";
}

// Where signed-in people land: today's bookings first, before they log a visit.
export const HOME = "/app/calendar";

// New owners confirm a mobile number once, before anything else. The server enforces it; this just routes people.
export const needsPhoneCheck = (u) => !!u && !!u.phone_verification_required && !u.phone_verified;
export const PHONE_PATH = "/verify-phone";

export const money = (n) =>
  n === null || n === undefined || isNaN(n)
    ? "—"
    : "₹" + Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 });

export const uid = () =>
  (crypto.randomUUID && crypto.randomUUID()) || String(Date.now() + Math.random());

// Patient ID order (1, 2, 3 … 10, 11), matching the clinic's paper files. Patients
// without an ID go last, alphabetically.
export const byPatientId = (a, b) => {
  const ca = Number(a.code), cb = Number(b.code);
  const ha = Number.isFinite(ca) && a.code != null && a.code !== "";
  const hb = Number.isFinite(cb) && b.code != null && b.code !== "";
  if (ha && hb && ca !== cb) return ca - cb;
  if (ha !== hb) return ha ? -1 : 1;
  return (a.name || "").localeCompare(b.name || "");
};
